import { useState, useEffect } from 'react';
import { Box, Card, CardContent, Typography, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';
import { useAuth } from '../../AuthContext';
import { tokens } from '../../theme';
import { useTheme } from '@mui/material';
import { toast } from 'react-toastify';
import EditIcon from '@mui/icons-material/Edit';

const Profile = ({ userId }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { getData, updateData } = useAuth();
  const [profile, setProfile] = useState({ FirstName: '', LastName: '', email: '', department: '' });
  const [openProfileDialog, setOpenProfileDialog] = useState(false);
  const [formData, setFormData] = useState({ FirstName: '', LastName: '', email: ''});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchProfile() {
      try {
        const response = await getData('proccess.php', 'staffs', userId );
        if (response.success) {
          setProfile(response.data[0]);
          setFormData(response.data[0]);
        } else {
          toast.error(response.message || "Failed to load profile");
        }
      } catch (err) {
        toast.error("Network error: Failed to fetch profile");
        console.error("Fetch error:", err);
      } finally {
        setLoading(false);
      }
    }
    fetchProfile();
  }, [userId, getData]);

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleProfileSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await updateData('proccess.php', 'staffs', formData, userId);
      if (response.success) {
        toast.success("Profile updated successfully");
        setProfile(response.data);
        setOpenProfileDialog(false);
      } else {
        toast.error(response.message || "Failed to update profile");
      }
    } catch (err) {
      toast.error("Network error: Failed to update profile");
      console.error("Profile update error:", err);
    }
  };

  return (
    <Box mt={2}>
      <Card sx={{ backgroundColor: colors.primary[500] }}>
        <CardContent>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h5">Profile Details</Typography>
            <IconButton onClick={() => setOpenProfileDialog(true)}>
              <EditIcon />
            </IconButton>
          </Box>
          {loading ? (
            <Typography>Loading...</Typography>
          ) : (
            <>
              <Typography>First Name: {profile.FirstName}</Typography>
              <Typography>Last Name: {profile.LastName}</Typography>
              <Typography>Email: {profile.email}</Typography>
              <Typography>Department: {profile.department}</Typography>
            </>
          )}
        </CardContent>
      </Card>

      <Dialog open={openProfileDialog} onClose={() => setOpenProfileDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Edit Profile</DialogTitle>
        <DialogContent>
          <Box component="form" onSubmit={handleProfileSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
            <TextField
              label="First Name"
              name="firstName"
              value={formData.FirstName}
              onChange={handleFormChange}
              required
            />
            <TextField
              label="Last Name"
              name="lastName"
              value={formData.LastName}
              onChange={handleFormChange}
              required
            />
            <TextField
              label="Email"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleFormChange}
              required
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenProfileDialog(false)}>Cancel</Button>
          <Button type="submit" onClick={handleProfileSubmit} variant="contained" sx={{ backgroundColor: colors.blue[400] }}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Profile;